<div class="modal-header">
  <h4 class="modal-title pull-left no-text-transform"> {{'selling.bracelet_activated_modal_description' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="container-fluid text-center">
</div>
<div class="modal-footer d-center-center">
  <!-- <app-product-carousel 
    [isModal]="true"
    [preloadedProducts]="true"
    [suggestedProducts]="suggestedProducts"
    class="w100">
  </app-product-carousel> -->
</div>